import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { setLocale } from '@allswipes/ui';

import '@allswipes/ui/tokens.css';
import './app.css';

import { LangProvider, onLocaleChange } from '@allswipes/i18n';

import { api } from './api';
import { App } from './App';
import { SessionProvider } from './session';
import { ToastProvider } from './toast';

// Даты и числа печатает пакет ui — отдаём ему тот же язык, что у интерфейса.
onLocaleChange(setLocale);

const root = document.getElementById('root');
if (!root) throw new Error('не найден #root');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      {/* Язык приложения задаёт и язык контента: клиент API просит у сервера
          акции на том же языке, на котором нарисован интерфейс. */}
      <LangProvider
        onChange={(lang) => {
          api.lang = lang;
        }}
      >
        <SessionProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </SessionProvider>
      </LangProvider>
    </BrowserRouter>
  </StrictMode>,
);
